import { render } from "./ImgVideoCommon.vue?vue&type=template&id=4ef60bd4&scoped=true"
import script from "./ImgVideoCommon.vue?vue&type=script&lang=js"
export * from "./ImgVideoCommon.vue?vue&type=script&lang=js"

import "./ImgVideoCommon.vue?vue&type=style&index=0&id=4ef60bd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ef60bd4"

export default script